// extracted by mini-css-extract-plugin
export default {"SidebarItems":"SidebarItems_SidebarItems__X6IDW"};